import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps } from 'types';
import customerDedRepay from './CustomerDeductionRepay';
import customerDeduction from './CustomerDeduction';
import dotBillback from './Billback';
import dotCreditToSupplier from './CreditToSupplier';
import discounts from './Discount';
import priceAdjustment from './PriceAdjustment';
import quantityAdjustment from './QuantityAdjustment';

const map = new Map<AdjustmentType, AdjustmentCategoryGridProps>();
map.set(AdjustmentType.CustomerDedRepay, customerDedRepay);
map.set(AdjustmentType.CustomerDeduction, customerDeduction);
map.set(AdjustmentType.DotBillback, dotBillback);
map.set(AdjustmentType.DotCreditToSupplier, dotCreditToSupplier);
map.set(AdjustmentType.Discount, discounts);
map.set(AdjustmentType.Pricing, priceAdjustment);
map.set(AdjustmentType.Quantity, quantityAdjustment);
export default map;